import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getOrderSummary } from 'features/order-tracker/store/selectors';
import { setNotificationType } from 'features/order-tracker/store/actions';
import { WARNING_HIGH_DEMAND } from 'features/order-tracker/pages/AmendAppointmentPage/components/Notification/constants';


export const useHighDemandEngineerVisitsBannerManager = (): void => {
  const { hasHighDemandEngineerVisitsBanner } = useSelector(getOrderSummary);
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasHighDemandEngineerVisitsBanner) {
      dispatch(setNotificationType(WARNING_HIGH_DEMAND));
    }
  }, [hasHighDemandEngineerVisitsBanner]);
};
